// extracted by mini-css-extract-plugin
export default {"map":"Map_map__j-PAK","ol-control":"Map_ol-control__xIEgP","ol-full-screen":"Map_ol-full-screen__6A15B"};